import styled from "styled-components";

export const WhatnotPageContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0px 48px;
    padding-bottom: 48px;
    width: 100%;
`;

/* ─── Shows rail ──────────────────────────────────────────────────────────── */

export const ShowsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ShowRail = styled.div`
    align-items: stretch;
    display: flex;
    gap: 8px;
    overflow-x: auto;
    width: 100%;

    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,0.15) transparent;
    &::-webkit-scrollbar { height: 4px; }
    &::-webkit-scrollbar-track { background: transparent; }
    &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
`;

export const NewShowBtn = styled.button`
    align-items: center;
    background: transparent;
    border: 1px dashed rgba(255, 255, 255, 0.25);
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-weight: 600;
    gap: 6px;
    justify-content: center;
    letter-spacing: 0.06em;
    padding: 12px 20px;
    text-transform: uppercase;
    transition: all 0.2s ease;
    white-space: nowrap;
    width: 120px;

    &:hover {
        background: rgba(255, 255, 255, 0.06);
        border-color: rgba(255, 255, 255, 0.4);
        color: rgba(255, 255, 255, 0.85);
    }

    svg { height: 18px; width: 18px; }
`;

export const ShowCard = styled.div`
    align-items: flex-start;
    background: ${({ $active }) => $active ? 'rgba(255,255,255,0.14)' : 'rgba(255,255,255,0.06)'};
    border: 1px solid ${({ $active }) => $active ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.12)'};
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 8px;
    padding: 12px 16px;
    transition: all 0.2s ease;
    width: 160px;

    &:hover {
        background: rgba(255, 255, 255, 0.11);
        border-color: rgba(255, 255, 255, 0.28);
        transform: translateY(-1px);
    }
`;

export const ShowCardTitle = styled.div`
    color: #fff;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`;

export const ShowCardDate = styled.div`
    color: rgba(255, 255, 255, 0.4);
    font-family: 'Inter', sans-serif;
    font-size: 10px;
    letter-spacing: 0.03em;
`;

export const ShowCardStatus = styled.div`
    background: ${({ $status }) => {
        if ($status === 'live')  return 'rgba(74,222,128,0.15)';
        if ($status === 'ended') return 'rgba(255,255,255,0.06)';
        return 'rgba(255,255,255,0.08)';
    }};
    border: 1px solid ${({ $status }) => {
        if ($status === 'live')  return 'rgba(74,222,128,0.4)';
        if ($status === 'ended') return 'rgba(255,255,255,0.1)';
        return 'rgba(255,255,255,0.18)';
    }};
    border-radius: 99px;
    color: ${({ $status }) => {
        if ($status === 'live')  return 'rgb(74,222,128)';
        if ($status === 'ended') return 'rgba(255,255,255,0.3)';
        return 'rgba(255,255,255,0.6)';
    }};
    font-family: 'Inter', sans-serif;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.08em;
    padding: 2px 8px;
    text-transform: uppercase;
    width: fit-content;
`;

/* ─── CSV config panel ────────────────────────────────────────────────────── */

export const ConfigPanel = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 20px 24px;
    width: 100%;
`;

export const ConfigFieldsContainer = styled.div`
    display: flex;
    gap: 16px;
`;

export const ConfigActions = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 12px;
`;

export const AddCardBtn = styled.button`
    align-items: center;
    background: transparent;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    display: flex;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    gap: 6px;
    height: 40px;
    letter-spacing: 0.05em;
    padding: 0 16px;
    text-transform: uppercase;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.5);
        color: rgba(255, 255, 255, 0.9);
    }
`;

export const ItemCount = styled.span`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    padding: 4px 12px;
    text-transform: uppercase;
`;

export const ExportBtn = styled.button`
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 8px;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font-size: 13px;
    font-weight: 600;
    gap: 8px;
    height: 40px;
    padding: 0px 16px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:disabled { cursor: not-allowed; opacity: 0.35; }
    &:not(:disabled):hover {
        background: rgba(255, 255, 255, 0.18);
        border-color: rgba(255, 255, 255, 0.4);
        transform: translateY(-1px);
    }
`;

/* ─── Selection bar ───────────────────────────────────────────────────────── */

export const QueueControls = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    min-height: 60px;
    transition: background 0.2s ease, border-color 0.2s ease;
    width: 100%;
`;

export const QueueHeader = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const QueueHeaderActions = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 12px;
`;

export const SelectAllContainer = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 8px;
    background: ${({ $expanded }) => $expanded ? 'rgba(255, 255, 255, 0.10)' : 'none'};
    border: 1px solid ${({ $expanded }) => $expanded ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.12)'};
    border-radius: 12px;
    padding: 12px;
`;

export const MiddleContent = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 640px;
`;

export const RightContent = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 8px;
    padding: 12px;
`;

export const SelectionCount = styled.span`
    color: rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    white-space: nowrap;
`;

export const ShowSelectDropdown = styled.select`
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    flex: 1;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
    height: 36px;
    max-width: 240px;
    min-width: 0;
    outline: none;
    padding: 0 10px;
    transition: border-color 0.2s ease;

    option { background: #1a1a1f; color: #fff; }
    &:focus { border-color: rgba(255, 255, 255, 0.4); }
`;

export const AddToShowActionBtn = styled.button`
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 36px;
    letter-spacing: 0.06em;
    padding: 0 18px;
    text-transform: uppercase;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:disabled { cursor: not-allowed; opacity: 0.35; }
    &:not(:disabled):hover {
        background: rgba(255, 255, 255, 0.22);
        border-color: rgba(255, 255, 255, 0.5);
    }
`;

/* ─── States ──────────────────────────────────────────────────────────────── */

export const EmptyState = styled.div`
    align-items: center;
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.4);
    display: flex;
    flex-direction: column;
    font-size: 14px;
    gap: 8px;
    justify-content: center;
    padding: 64px 24px;
    text-align: center;
    width: 100%;

    p {
        color: rgba(255, 255, 255, 0.25);
        font-size: 12px;
        margin: 0;
    }
`;

export const LoadingState = styled.div`
    color: rgba(255, 255, 255, 0.4);
    font-size: 14px;
    padding: 48px 0;
    text-align: center;
`;

/* ─── New show modal ──────────────────────────────────────────────────────── */

export const ModalOverlay = styled.div`
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1000;
`;

export const ModalCard = styled.div`
    background: #1a1a1f;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px 16px 16px;
    width: ${({ $wide }) => ($wide ? '768px' : '380px')};

    h2 {
        margin-bottom: 8px;
    }
`;

export const ModalActions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
`;

export const ModalCancelBtn = styled.button`
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    padding: 8px 16px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:hover {
        border-color: rgba(255, 255, 255, 0.35);
        color: rgba(255, 255, 255, 0.8);
    }
`;

export const ModalCreateBtn = styled.button`
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    padding: 8px 16px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:disabled { cursor: not-allowed; opacity: 0.3; }
    &:not(:disabled):hover {
        background: rgba(255, 255, 255, 0.22);
        border-color: rgba(255, 255, 255, 0.5);
    }
`;

export const CombineLotBtn = styled.button`
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 36px;
    letter-spacing: 0.06em;
    padding: 0 14px;
    text-transform: uppercase;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:disabled { cursor: not-allowed; opacity: 0.35; }
    &:not(:disabled):hover {
        background: rgba(255, 255, 255, 0.22);
        border-color: rgba(255, 255, 255, 0.5);
    }
`;

export const DescriptionPreviewLabel = styled.div`
    color: rgba(255, 255, 255, 0.45);
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    margin-bottom: 8px;
    text-transform: uppercase;
`;

export const ModalFieldsGrid = styled.div`
    display: grid;
    gap: 12px 8px;
    grid-template-columns: ${({ $cols }) => $cols === 2 ? '1fr 1fr' : '1fr 1fr 1fr'};
`;


export const DescriptionPreview = styled.pre`
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 0.75);
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    line-height: 1.5;
    margin: 0;
    max-height: 200px;
    overflow-y: auto;
    padding: 12px;
    white-space: pre-wrap;
    width: 100%;
`;
